export const genName = (subregion, idx) => {
    return subregion.name || `Subregion ${idx}`;
};

export const getPrefWarehouse = (id, locations = []) => {
    return locations.reduce((acc, location) => {
        if (id) {
            return location.location_id === id ? location : acc;
        } else {
            return location.preferred_inbound ? location : acc;
        }
    }, locations[0]);
};
